import { useTheme } from '@mui/material/styles';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { SxProps } from '@mui/system';
import { t } from 'i18next';

import { SimpleCard } from '~components/Cards/SimpleCard';

interface Props {
  label?: string;
  value?: string;
  sx?: SxProps<Theme>;
}

const Notes = ({ label, value, sx = {} }: Props) => {
  const theme = useTheme();

  return (
    <>
      <Typography variant="group-title">{label ?? t('form_fields.notes')}</Typography>

      {value ? (
        <SimpleCard
          sx={{
            background: theme.semantic.surfaceSunken,
            borderRadius: 1,
            p: 0,
            ...sx,
          }}
        >
          {value}
        </SimpleCard>
      ) : (
        <Typography variant="body1" sx={{ fontStyle: 'italic', ...sx }}>
          {t('common.empty')}
        </Typography>
      )}
    </>
  );
};

export { Notes };
